import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

window.addEventListener('popstate', () => {
  if (window._vue_onpopstate) window._vue_onpopstate()
})

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/works',
    name: 'Works',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "works" */ '../views/Works.vue')
  },
  {
    path: '/works/:workId',
    name: 'Detail',
    component: () => import(/* webpackChunkName: "detail" */ '../views/Detail.vue')
  },
  {
    path: '/news',
    name: 'NewsList',
    component: () => import(/* webpackChunkName: "newslist" */ '../views/NewsList.vue')
  }, {
    path: '/news/page/:id',
    name: 'NewsListPage',
    component: () => import( /* webpackChunkName: "newslistpage" */ '../views/NewsList.vue')
  },
  {
    path: '/news/:newsId',
    name: 'NewsDetail',
    component: () => import(/* webpackChunkName: "newsdetail" */ '../views/NewsDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      sessionStorage.setItem('positionY', savedPosition.y);
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 600)
      })
    } else if (to.name == from.name) {
      sessionStorage.setItem('positionY', 0);
      return savedPosition
    } else {
      sessionStorage.setItem('positionY', 0);
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router
